// import smc_logo from "assets/img/smc-Logo.png";
const smc_logo = "https://smc-infra.s3.ap-south-1.amazonaws.com/content/LOGO-FINAL.png";
const details = {
  companyName: "SMC LMS",
  companyLogo: smc_logo,
};

const hideChannels = ["AGENT", "APP_TOPUP"];

export default {
  details,
  hideChannels,
};


